'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var Snackbar = _interopDefault(require('@material-ui/core/Snackbar'));

var BottomCenterSnackbar = function (props) {
    var message = props.message, open = props.open, onClose = props.onClose;
    return (React__default.createElement(Snackbar, { anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center',
        }, open: open, autoHideDuration: 6000, onClose: onClose, message: message }));
};

module.exports = BottomCenterSnackbar;
